import { AxiosResponse } from 'axios';
import http from './http-common';

class TenantPortalService {
  async updateTenantWorkOrderForm(propertyId: string, enabled: boolean): Promise<AxiosResponse> {
    return http.post('/property/work-order-form/update', { propertyId, enabled });
  }
}

const tenantPortalService = new TenantPortalService();
export default tenantPortalService;
